import { clsx } from 'modules/Utils';
import { CreateNewArtistImage } from "../style";
import CreateNewBrand from 'assets/images/CreateNewBrand.png';
import ButtonSymphony from 'elements/ButtonSymphony';
import styled from 'styled-components';
import Sty from "modules/Sty";
import { CSSProperties } from 'react';
import Banner from 'elements/Banner';
import Divider from 'elements/Divider';

type GlobalWindow = Window & {
    Intercom: (type: string, article?: number) => void;
};

interface NotFoundArtistLabelProps {
    className?: string
    onClickCreateNewProfile: () => void;
    searchStr: string;
}

const NotFoundArtistLabel = ({
    className,
    onClickCreateNewProfile,
    searchStr
}: NotFoundArtistLabelProps) => {
    const handleClickLearnHow = () => {
        (window as unknown as GlobalWindow).Intercom("showArticle", 5678366);
    };

    return (
        <div
            className={clsx("notFoundArtistLabelComponent", className)}
            style={sty.notFoundArtistLabelComponent}
        >
            <div className="learnHowOnboardingText1">
                Can't find your profile? Try pasting in your Spotify profile URL.
            </div>
            <ButtonSymphony
                className="learnHowOnboarding"
                onClick={handleClickLearnHow}
                variant="text"
            >
                Learn how
            </ButtonSymphony>
            <Divider />
            <div>Or create a new profile for <span style={Sty.text16bold}>"{searchStr}"</span></div>
            <Divider />
            <Banner
                className="createNewProfileBanner"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 16,
                }}
            >
                <CreateNewArtistImage src={CreateNewBrand} />
                <ButtonSymphony
                    className="createNewProfileButton"
                    onClick={onClickCreateNewProfile}
                    size="large"
                    style={{
                        flexShrink: 0,
                    }}
                    styleButtonContent={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        justifyContent: "flex-start",
                        maxWidth: 400,
                    }}
                >
                    Create new profile: {searchStr}
                </ButtonSymphony>
            </Banner>
        </div>
    );
};

const sty: Record<string, CSSProperties> = {
    notFoundArtistLabelComponent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 8,
        width: "100%",
    }
}

export const NoArtistItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
    gap: 8px;
    height: 25px;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
`

export default NotFoundArtistLabel;
